import React, { Component } from "react";
import Modal from "antd/lib/modal/Modal";
import styles from "./ModalWindow.module.css";

const ModalWindowContext = React.createContext({});

interface IModalWindowProps {
  visible: boolean;
  data?: any;
  title?: string;
  className?: string;
  centered?: boolean;
  fullScreen?: boolean;
  updateState?: any;
  width?: string;
  children?: React.ReactNode;
}

class ModalWindow extends Component<IModalWindowProps> {
  constructor(props: IModalWindowProps) {
    super(props);
    this.close = this.close.bind(this);
  }

  close() {
    const { updateState } = this.props;
    updateState && updateState(null);
  }

  render() {
    const {
      visible,
      data,
      title,
      children,
      className,
      centered = true,
      fullScreen,
      width,
    } = this.props;

    return (
      <>
        <Modal
          open={visible}
          centered={centered}
          footer={null}
          destroyOnClose={true}
          title={title}
          width={width}
          className={`${className} ${fullScreen ? styles.modalFullscreen : ""}`}
          onCancel={this.close}
        >
          <ModalWindowContext.Provider value={data}>
            {children}
          </ModalWindowContext.Provider>
        </Modal>
      </>
    );
  }
}

export default ModalWindow;
